import { Component, Input, effect } from '@angular/core';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import * as _ from 'lodash'
import { NgIf } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../../../shared/components/ltms-loader/ltms-loader.component';

@Component({
    selector: 'app-action-tat-overall',
    templateUrl: './action-tat-overall.component.html',
    styleUrls: ['./action-tat-overall.component.scss'],
    imports: [NgIf, LtmsLoaderComponent]
})
export class ActionTatOverallComponent {
  @Input() totalResponses: string | null = '';
  @Input() totalActionableResponses: string | null = '';
  tatHours: any = 0;
  leftUpperBoxHeading: string = 'Actionable Issues';
  leftUpperBoxDiscription: string = 'Viewing average TAT for solved Actionable Issues. TAT is time from issue creation till closure. Target TAT is '+ this.tatHours +' hours.';
  constructor(
    private _appStateService: AppStateService
  ) {
    effect(() => {
      if (this._appStateService.initialized()) {
        const brandDetails: any = this._appStateService.brandDetails()
        this.tatHours = _.get(brandDetails, "action_management_configuration.ageing_config.turnaround_time", 0);
        this.leftUpperBoxDiscription = 'Viewing average TAT for solved Actionable Issues. TAT is time from issue creation till closure. Target TAT is '+ this.tatHours +' hours.';
      }
    })
  }
}
